// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"pK-z","carouselContainer":"qK-z"};